import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateTrainingMutation as UpdateTrainingMutationType,
  UpdateTrainingMutationVariables,
} from "./__generated__/UpdateTrainingMutation";

const UpdateTrainingMutation = loader("./UpdateTrainingMutation.gql");

type UpdateTrainingMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateTrainingMutationType) => void;
}) => ReactElement;

export const UpdateTrainingMutationProvider: UpdateTrainingMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateTrainingMutationType, UpdateTrainingMutationVariables>(
    UpdateTrainingMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
